export type Lang = 'ru' | 'en' | 'kk' | 'ky' | 'uz';
const KEY = 'bpcrm_lang';

type Dict = Record<string, string>;
const LOADERS: Record<Exclude<Lang, 'ru'>, () => Promise<{ default: Dict }>> = {
  en: () => import('./i18n/en'),
  kk: () => import('./i18n/kk'),
  ky: () => import('./i18n/ky'),
  uz: () => import('./i18n/uz'),
};
export const LOCALES: Record<Lang, string> = { ru: 'ru-RU', en: 'en-US', kk: 'kk-KZ', ky: 'ky-KG', uz: 'uz-Latn-UZ' };
export const LANG_NAMES: Record<Lang, string> = {
  ru: 'Русский',
  en: 'English',
  kk: 'Қазақша',
  ky: 'Кыргызча',
  uz: 'Oʻzbekcha',
};
export const LANGS: Lang[] = ['ru', 'en', 'kk', 'ky', 'uz'];

const stored = localStorage.getItem(KEY);
export const lang: Lang = LANGS.includes(stored as Lang) ? (stored as Lang) : 'ru';
export const LOCALE = LOCALES[lang];

document.documentElement.lang = lang;

export function setLang(next: Lang) {
  if (next === lang || !LANGS.includes(next)) return;
  localStorage.setItem(KEY, next);
  window.location.reload();
}

let dict: Dict | null = null;

export async function loadDict() {
  if (lang !== 'ru') dict = (await LOADERS[lang]()).default;
}

export function tr(key: string, args?: unknown[]): string {
  const text = dict && Object.prototype.hasOwnProperty.call(dict, key) ? dict[key] : key;
  return args ? text.replace(/\{(\d+)\}/g, (_, i) => String(args[Number(i)])) : text;
}
